import { NgModule } from '@angular/core';
import { DragAndDropDirective } from './drag-and-drop.directive';

@NgModule({
  imports: [],
  declarations: [DragAndDropDirective],
  exports: [DragAndDropDirective]
})
export class DragAndDropModule { } 
